import {
  type UseTrackAgentTaskSubmittedParams,
  WORKSPACE_AGENT_GUIDED_FLOW_ACTIONS_MENU_TASK_ID,
  type WorkspaceAgentGuidedFlowSubmissionParams,
  type WorkspaceAgentTaskSubmittedType,
} from '@air/analytics';

type BuildAgentTaskSubmittedSkillParams = {
  sessionId: string;
  skillIds: readonly string[];
};

type BuildAgentTaskSubmittedParams = BuildAgentTaskSubmittedSkillParams &
  (
    | {
        guidedFlowSubmission: WorkspaceAgentGuidedFlowSubmissionParams;
        type: 'guided_flow';
      }
    | {
        actionsMenuTaskId: string | undefined;
        type: Exclude<WorkspaceAgentTaskSubmittedType, 'guided_flow'>;
      }
  );

const buildAgentTaskSubmittedSkillParams = (skillIds: readonly string[]) => {
  const containsSkill = skillIds.length > 0;

  return {
    contains_skill: containsSkill,
    skill_count: skillIds.length,
    ...(containsSkill ? { skill_ids: [...skillIds] } : {}),
  };
};

export const buildAgentTaskSubmittedParams = (
  params: BuildAgentTaskSubmittedParams,
): UseTrackAgentTaskSubmittedParams => {
  const skillParams = buildAgentTaskSubmittedSkillParams(params.skillIds);

  if (params.type === 'guided_flow') {
    return {
      ...skillParams,
      actions_menu_task_id: WORKSPACE_AGENT_GUIDED_FLOW_ACTIONS_MENU_TASK_ID,
      session_id: params.sessionId,
      type: 'guided_flow',
      ...params.guidedFlowSubmission,
    };
  }

  if (params.type === 'actions_menu' && params.actionsMenuTaskId) {
    return {
      ...skillParams,
      actions_menu_task_id: params.actionsMenuTaskId,
      session_id: params.sessionId,
      type: params.type,
    };
  }

  return {
    ...skillParams,
    session_id: params.sessionId,
    type: params.type,
  };
};
